// const SERVER_BASE_URL = "https://sandbox-api.transparencyfleet.com/graphql";
//const SERVER_BASE_URL = "https://api.transparencyfleet.com/graphql";

const SERVER_BASE_URL = "https://10.60.0.6/graphql";

//const SERVER_BASE_URL = "http://localhost:3000/graphql";

export default SERVER_BASE_URL;
